import { Text } from '@wartek-id/text'

import { formatNumber } from '@/utils/string'
import { CellRenderer } from '@/utils/table'

export const CustomStatisticNestedCellRenderer = ({ row, col }) => {
  const value = row.getValue()
  const originalRowData = row?.row?.original || {}

  if (col?.id === 'variable') {
    const haveNumber =
      typeof originalRowData?.number !== 'undefined' &&
      originalRowData?.number !== 0
    const tab = originalRowData?.tab || 0
    const paddingLeft = tab <= 1 ? 0 : 10 * (tab - 1)
    return (
      <div
        data-type="variable"
        style={{
          paddingLeft: `${paddingLeft}px`,
        }}
      >
        <Text variant={haveNumber ? 'body-bold' : 'body'}>{value}</Text>
      </div>
    )
  }

  if (col?.id === 'number') {
    const isNeedToShow = typeof value !== 'undefined' && value !== 0
    if (isNeedToShow) {
      return (
        <div data-type="number" className="text-right">
          <Text variant="body-bold">{formatNumber(value)}</Text>
        </div>
      )
    }
    return <div data-type="skip"></div>
  }

  return <CellRenderer getValue={row.getValue} />
}
